<div class="display-career-valuation-organisation-statistics"
     *adaptLoading="isLoading">
    @if (careerValuationsHaveBeenRecorded) {
        <div class="card">
            <div class="card-body">
                @if (!filterService.isDefault) {
                    <div class="float-end">
                        <i class="ms-auto align-self-start fal fa-fw fa-info-circle adapt-tooltip adapt-tooltip-enabled"
                           adaptTooltip="These numbers are based on the applied filters."></i>
                    </div>
                }
                <div class="active-people">
                    <span class="number"
                          data-test="active-people">{{ statisticsData!.totalPeople }}</span>
                    people with career valuations
                </div>
                <div class="ps-2">
                    <span data-test="total-people">{{ activePeopleCount }}</span>
                    people in the organisation
                </div>
                <div class="missing-catchups-accordion pt-3">
                    @if (canSeeData && statisticsAccordion?.length !== 0) {
                        <dx-accordion [dataSource]="statisticsAccordion"
                                      (onContentReady)="onAccordionReady($event)"
                                      [collapsible]="true"
                                      [selectedIndex]="-1"
                                      itemTitleTemplate="itemTitleTemplate"
                                      itemTemplate="itemTemplate">
                            <div *dxTemplate="let item of 'itemTitleTemplate'">
                                {{ item.text }}
                            </div>
                            <div *dxTemplate="let item of 'itemTemplate'">
                                <dx-list [dataSource]="item.people"
                                         itemTemplate="item"
                                         [height]="240">
                                    <div *dxTemplate="let person of 'item'">
                                        <adapt-link-person [person]="person"
                                                           [showImage]="true"></adapt-link-person>
                                    </div>
                                </dx-list>
                            </div>
                        </dx-accordion>
                    }
                </div>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Actual valuations</h2>
            </div>
            <div class="card-body">
                <adapt-cvt-organisation-actuals-chart [date]="date"> </adapt-cvt-organisation-actuals-chart>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Average valuation</h2>
            </div>
            <div class="card-body">
                <adapt-analyse-cvt-average-gauge [value]="statisticsData!.averageCareerValuation"> </adapt-analyse-cvt-average-gauge>
            </div>
        </div>
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Ideal valuations</h2>
            </div>
            <div class="card-body">
                <dx-pie-chart (onInitialized)="onIdealsChartInitialized($event)"
                              [palette]="idealsPalette"
                              class="career-valuation-ideals-chart"
                              [dataSource]="statisticsData!.categoryStats"
                              [pathModified]="true"
                              type="doughnut">
                    <dxi-pie-chart-series argumentField="name"
                                          valueField="averageIdeal"
                                          tagField="id"></dxi-pie-chart-series>
                    <dxo-pie-chart-tooltip [enabled]="true">
                        <dxo-pie-chart-format type="fixedPoint"
                                              [precision]="1"></dxo-pie-chart-format>
                    </dxo-pie-chart-tooltip>
                    <dxo-pie-chart-legend [customizeText]="customizeIdealsChartLegendText"></dxo-pie-chart-legend>
                </dx-pie-chart>
            </div>
        </div>
        @if (canSeeData) {
            <div class="card">
                <div class="card-header">
                    <h2 class="card-title">Overdue catch-ups</h2>
                </div>
                <div class="card-body">
                    <dx-pie-chart [dataSource]="statisticsData!.overdueCatchups"
                                  [palette]="overdueCatchupsPalette"
                                  (onInitialized)="onInitialized($event)"
                                  resolveLabelOverlapping="shift">
                        <dxo-pie-chart-margin [left]="60"></dxo-pie-chart-margin>
                        <dxi-pie-chart-series argumentField="label"
                                              valueField="value">
                            <dxo-pie-chart-label [visible]="true"
                                                 textOverflow="none"
                                                 position="outside">
                                <dxo-pie-chart-connector [visible]="true"
                                                         [width]="1"></dxo-pie-chart-connector>
                            </dxo-pie-chart-label>
                        </dxi-pie-chart-series>
                        <dxo-pie-chart-legend [visible]="true"></dxo-pie-chart-legend>
                    </dx-pie-chart>
                </div>
            </div>
        }
        <div class="card">
            <div class="card-header">
                <h2 class="card-title">Valuation distribution</h2>
            </div>
            <div class="card-body">
                <dx-polar-chart (onInitialized)="onDistributionChartInitialized($event)"
                                [customizePoint]="customiseDistributionChartPoint"
                                [dataSource]="valuationOrbitData"
                                class="career-valuation-totals-chart">
                    <dxo-polar-chart-common-series-settings type="scatter"> </dxo-polar-chart-common-series-settings>
                    <dxo-polar-chart-argument-axis>
                        <dxo-polar-chart-label [visible]="false"></dxo-polar-chart-label>
                        <dxo-polar-chart-minor-tick [visible]="false"></dxo-polar-chart-minor-tick>
                        <dxo-polar-chart-tick [visible]="false"></dxo-polar-chart-tick>
                        <dxo-polar-chart-grid [visible]="false"></dxo-polar-chart-grid>
                        <dxo-polar-chart-minor-grid [visible]="false"></dxo-polar-chart-minor-grid>
                    </dxo-polar-chart-argument-axis>
                    <dxo-polar-chart-value-axis [visualRange]="{ startValue: 0, endValue: 100 }"
                                                [tickInterval]="20"
                                                [maxValueMargin]="0.001"
                                                visualRangeUpdateMode="keep">
                        <dxo-polar-chart-label [visible]="false"></dxo-polar-chart-label>
                        <dxo-polar-chart-minor-tick [visible]="false"></dxo-polar-chart-minor-tick>
                        <dxo-polar-chart-tick [visible]="false"></dxo-polar-chart-tick>
                        <dxo-polar-chart-minor-grid [visible]="false"></dxo-polar-chart-minor-grid>
                    </dxo-polar-chart-value-axis>
                    <dxi-polar-chart-series argumentField="index"
                                            valueField="value"
                                            tagField="careerValuation"> </dxi-polar-chart-series>
                    <dxo-polar-chart-legend [visible]="false"></dxo-polar-chart-legend>
                    <dxo-polar-chart-tooltip [enabled]="true"
                                             [customizeTooltip]="customiseDistributionTooltip"></dxo-polar-chart-tooltip>
                    <dxo-polar-chart-loading-indicator [enabled]="true"></dxo-polar-chart-loading-indicator>
                </dx-polar-chart>
            </div>
        </div>
    } @else {
        <adapt-no-cultural-measurement label="Career Valuations"></adapt-no-cultural-measurement>
    }
</div>
